import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteRelatedContentTagsComponent } from './website-related-content-tags.component'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
  imports: [CommonModule, SharedModule, PipesModule],
  declarations: [WebsiteRelatedContentTagsComponent],
  exports: [WebsiteRelatedContentTagsComponent],
  providers: [],
})
export class WebsiteRelatedContentTagsModule {
}
